var ATTR = 'data-seo-managed'
var SEO_RE = /^(description|keywords|robots|author|og:|twitter:)/i
var IMAGE_META_RE = /^(og:image|twitter:image)(:|$)/i
var seq = 0

function clearSeo () {
  var head = document.head
  if (!head) return
  head.querySelectorAll('[' + ATTR + '],link[rel="canonical"]').forEach(function (el) {
    el.parentNode && el.parentNode.removeChild(el)
  })
  head.querySelectorAll('meta[name],meta[property]').forEach(function (el) {
    var name = el.getAttribute('property') || el.getAttribute('name') || ''
    if (SEO_RE.test(name)) el.parentNode && el.parentNode.removeChild(el)
  })
}

/** Soft SSR 常返回 OSS 相对路径；社交爬虫需要绝对 URL */
function absImageUrl (url) {
  if (!url) return url
  var u = String(url).trim()
  if (!u || /^(https?:|data:|\/\/)/i.test(u)) return u
  var base = (process.env.VUE_APP_OSS_URL || '').replace(/\/?$/, '/')
  if (!base) return u
  return base + u.replace(/^\//, '')
}

function normalizeMetaContent (name, content) {
  if (IMAGE_META_RE.test(name || '')) return absImageUrl(content)
  return content
}

function parseHtml (html) {
  var doc = new DOMParser().parseFromString(html, 'text/html')
  var titleEl = doc.querySelector('title')
  var canEl = doc.querySelector('link[rel="canonical"]')
  var metas = []
  doc.querySelectorAll('meta[name],meta[property]').forEach(function (el) {
    var attr = el.hasAttribute('property') ? 'property' : 'name'
    var name = el.getAttribute(attr) || ''
    if (!name || name === 'viewport') return
    metas.push({
      attr: attr,
      name: name,
      content: normalizeMetaContent(name, el.getAttribute('content') || '')
    })
  })
  return {
    title: titleEl && titleEl.textContent ? titleEl.textContent.trim() : '',
    canonical: canEl ? (canEl.getAttribute('href') || '') : '',
    metas: metas
  }
}

function isSsr (seo) {
  if (!seo) return false
  if (seo.canonical) return true
  return seo.metas.some(function (m) {
    return m.name === 'description' || m.name.indexOf('og:') === 0 || m.name.indexOf('twitter:') === 0
  })
}

function metaByName (metas, name) {
  for (var i = 0; i < metas.length; i++) {
    if (metas[i].name === name && metas[i].content) return metas[i].content
  }
  return ''
}

/**
 * Soft SSR 壳 title 有时仍是 route 兜底；meta 已是门户配置时优先用 og:title。
 * 避免被 App 侧 v-wechat-title 盖回后只剩兜底 title。
 */
function resolveTitle (seo, routeTitle) {
  var t = (seo.title || '').trim()
  var og = metaByName(seo.metas || [], 'og:title')
  if (t && (!routeTitle || t !== routeTitle)) return t
  if (og) return og
  return t || routeTitle || ''
}

function setDocumentTitle (title) {
  if (!title) return
  document.title = title
  // 压过页面 mounted 里晚到的 v-wechat-title（如曾把 title 设成商户 URL）
  ;[0, 50, 200].forEach(function (ms) {
    setTimeout(function () {
      if (document.title !== title) document.title = title
    }, ms)
  })
}

function apply (seo, routeTitle) {
  clearSeo()
  setDocumentTitle(resolveTitle(seo, routeTitle))
  if (seo.canonical) {
    var link = document.createElement('link')
    link.rel = 'canonical'
    link.href = seo.canonical
    link.setAttribute(ATTR, '1')
    document.head.appendChild(link)
  }
  seo.metas.forEach(function (item) {
    var el = document.createElement('meta')
    el.setAttribute(item.attr, item.name)
    el.setAttribute('content', normalizeMetaContent(item.name, item.content))
    el.setAttribute(ATTR, '1')
    document.head.appendChild(el)
  })
}

function fallback (title) {
  clearSeo()
  setDocumentTitle(title)
}

/**
 * SPA 跳转时同源拉取 Soft SSR HTML 同步 head。
 * 未命中 Soft SSR 或请求失败时清除上一页 SEO，回退 route title。
 */
export function syncRouteSeo (path, title) {
  var id = ++seq
  var p = path || '/'
  if (p.charAt(0) !== '/') p = '/' + p
  if (title) document.title = title
  fetch(p, { headers: { Accept: 'text/html' }, cache: 'no-cache' })
    .then(function (res) { return res.ok ? res.text() : Promise.reject() })
    .then(function (html) {
      if (id !== seq) return
      var seo = parseHtml(html)
      if (isSsr(seo)) apply(seo, title)
      else fallback(title)
    })
    .catch(function () {
      if (id !== seq) return
      fallback(title)
    })
}



// WEBPACK FOOTER //
// ./src/utils/seoHead.js